<template>
  <v-card flat>
    <div class="fixed-toolbar-info">
      <slot name="toolbar_info"></slot>
    </div>

    <slot />
    <v-card-actions>
      <slot name="actions_defaut" v-if="showButton">
        <v-btn
          v-if="isAllowedToModify"
          text
          @click="$emit('toggleUpdateButton')"
          :disabled="updateButtonClicked"
        >
          {{ $t('button.modify') }}
        </v-btn>
        <v-btn
          v-if="updateMode && deleteEnabled"
          text
          @click="modalDelete = true"
          :disabled="!isLockedByYou"
        >
          {{ $t('button.delete') }}</v-btn
        >
        <v-btn
          :loading="saving"
          type="submit"
          text
          color="primary"
          :disabled="!isLockedByYou"
          @click="$emit('save')"
          >{{ saveLabel }}</v-btn
        >
      </slot>
      <slot name="actions_droit" />
      <v-spacer />
      <slot name="actions_gauche" />
    </v-card-actions>

    <c-dialog persistent :dialog="modalDelete" max-width="50%">
      <c-delete-modal @remove="$emit('remove')" @close="modalDelete = false" />
    </c-dialog>

    <c-dialog persistent :dialog="internalModalLeave" max-width="50%">
      <alert-leave
        :alertTitle="$t('leaveTitle')"
        :alertMessage="$t('leaveConfirm')"
        @confirm="
          $emit('closeLeave');
          $store.commit('modif/modified', false);
          next();
        "
        @cancel="$emit('closeLeave')"
      />
    </c-dialog>
  </v-card>
</template>

<script>
import i18n from '@/utils/i18n';
import Mousetrap from 'mousetrap';

export default {
  props: {
    updateMode: {
      type: Boolean,
      required: true,
    },
    deleteEnabled: {
      type: Boolean,
      default: true,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    next: {
      type: Function,
      default: () => {},
    },
    modalLeave: {
      type: Boolean,
      default: false,
    },
    isLockedByYou: {
      type: Boolean,
      default: true,
    },
    isAllowedToModify: {
      type: Boolean,
      default: false,
    },
    updateButtonClicked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalDelete: false,
      internalModalLeave: false,
    };
  },
  computed: {
    deleting() {
      return this.$parent.deleting;
    },
    saving() {
      return this.$parent.saving;
    },
    modalText() {
      return i18n.code('form.deleteAll');
    },
    saveLabel() {
      return i18n.t(this.updateMode ? 'button.save' : 'button.create');
    },
  },
  mounted() {
    if (this.updateMode) {
      Mousetrap.bind(['del', 'backspace'], () => {
        this.modalDelete = false;
      });
    }

    Mousetrap.bind('shift+s', () => {
      this.$emit('save');
    });

    Mousetrap.bind('shift+z', () => {
      this.$router.go(-1);
    });
  },
  watch: {
    modalLeave(val) {
      this.internalModalLeave = val;
    },
  },
  beforeDestroy() {
    Mousetrap.unbind('del', 'backspace');
    Mousetrap.unbind('shift+h');
    Mousetrap.unbind('shift+s');
    Mousetrap.unbind('shift+z');
  },
};
</script>

<style scoped>
.v-btn--bottom:not(.v-btn--absolute) {
  bottom: 64px;
}

.fixed-toolbar-info {
  position: fixed;
  z-index: 10;
  top: 5px;
  right: 280px;
}
</style>
